import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import ChevronRight from '../icons/ChevronRight';
import { BreadcrumbsProps } from './types';

const Breadcrumbs = React.forwardRef(
  (props: BreadcrumbsProps, ref: React.RefObject<HTMLButtonElement>) => {
    const {
      children, iconSeparator, collapsed, ...rest
    } = props;

    return (
      <MuiBreadcrumbs
        separator={iconSeparator ? <ChevronRight /> : '/'}
        maxItems={collapsed ? 2 : undefined}
        {...rest}
        ref={ref}
      >
        {children}
      </MuiBreadcrumbs>
    );
  },
);

export default Breadcrumbs;
